import { useEffect, useRef, useState } from 'react';
import { lifeCards } from '../mock';

export default function Life() {
  const ref = useRef(null);
  const [active, setActive] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const onScroll = () => {
      const cardWidth = 220 + 20; // card + gap
      const idx = Math.round(el.scrollLeft / cardWidth);
      setActive(Math.min(idx, lifeCards.length - 1));
    };
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (i) => {
    const el = ref.current;
    if (!el) return;
    el.scrollTo({ left: i * (220 + 20), behavior: 'smooth' });
  };

  return (
    <section id="life" className="relative py-[50px]" style={{ background: 'linear-gradient(180deg, transparent 0%, rgba(237,232,220,0.6) 35%, transparent 100%)' }}>
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-10 md:mb-14">
          <div>
            <p className="reveal font-hand text-[26px] md:text-[30px] mb-2" style={{ color: 'var(--terracotta-deep)' }}>
              also me
            </p>
            <h2 className="reveal reveal-delay-1 font-display text-[38px] md:text-[54px] leading-tight" style={{ color: 'var(--ink)' }}>
              Outside <em className="italic" style={{ color: 'var(--terracotta)' }}>Figma</em>
            </h2>
            <p className="reveal reveal-delay-2 mt-4 text-[15.5px] italic max-w-xl" style={{ color: 'var(--ink-soft)' }}>
              I paint on weekends and design on weekdays — honestly can&apos;t tell which one is the job.
            </p>
          </div>
          <p className="reveal reveal-delay-3 font-hand text-[22px] md:text-[26px] max-w-sm text-right" style={{ color: 'var(--sage)' }}>
            painter · sunset chaser · iced coffee loyalist
          </p>
        </div>

        <div
          ref={ref}
          className="life-scroll flex gap-5 overflow-x-auto pb-3 -mx-6 px-6 md:-mx-10 md:px-10"
        >
          {lifeCards.map((c, i) => (
            <LifeCard key={i} c={c} />
          ))}
        </div>

        <div className="flex justify-center gap-2 mt-7">
          {lifeCards.map((_, i) => (
            <button
              key={i}
              onClick={() => scrollTo(i)}
              aria-label={`Go to slide ${i + 1}`}
              className="h-2 rounded-full transition-all duration-300"
              style={{
                width: active === i ? 26 : 8,
                background: active === i ? 'var(--terracotta)' : 'var(--border)',
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

function LifeCard({ c }) {
  return (
    <div
      className="life-card relative shrink-0 rounded-[18px] overflow-hidden shadow-warm group cursor-pointer"
      style={{ width: 220, height: 220, background: c.gradient }}
    >
      {c.image && (
        <img
          src={c.image}
          alt={c.caption}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          style={{ objectPosition: c.objectPosition || '50% 50%' }}
          loading="lazy"
        />
      )}
      {!c.image && (
        <div className="absolute inset-0 opacity-40" style={{
          backgroundImage:
            'radial-gradient(circle at 30% 20%, rgba(255,255,255,0.28), transparent 45%), radial-gradient(circle at 75% 85%, rgba(0,0,0,0.25), transparent 55%)',
        }} />
      )}
      <div
        className="absolute inset-0 p-5 flex items-end opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        style={{ background: 'linear-gradient(180deg, rgba(42,31,20,0) 40%, rgba(42,31,20,0.78) 100%)' }}
      >
        <p className="font-hand text-[19px] leading-snug" style={{ color: '#FAF6EE' }}>
          {c.caption}
        </p>
      </div>
    </div>
  );
}
